import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Tooltip = ({ text }) => {
  const [show, setShow]   = useState(false);
  const [pos,  setPos]    = useState({ top: 0, left: 0 });
  const btnRef            = useRef(null);

  useEffect(() => {
    if (show && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({
        top:  rect.top  + window.scrollY - 8,   // 8px gap above button
        left: rect.left + rect.width / 2,        // horizontally centered
      });
    }
  }, [show]);

  return (
    <span className="relative inline-flex items-center ml-1">
      <button
        ref={btnRef}
        type="button"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="w-3.5 h-3.5 rounded-full bg-white/10 text-white/40 hover:text-white hover:bg-white/20 transition-all text-[9px] font-bold flex items-center justify-center"
      >
        i
      </button>

      {show && createPortal(
        <div
          style={{ top: pos.top, left: pos.left, transform: 'translate(-50%, -100%)' }}
          className="fixed z-[9999] w-52 bg-[#0c1a35] border border-white/[0.12] rounded-xl px-3 py-2.5 text-white/70 text-[11px] leading-relaxed shadow-xl pointer-events-none"
        >
          {text}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-[#0c1a35]" />
        </div>,
        document.body
      )}
    </span>
  );
};

export default Tooltip;